/**
 * Normalizes text by removing accents and special characters
 * Converts to ASCII-compatible characters for WinAnsi encoding
 */
export function normalizeText(text: string): string {
  const map: Record<string, string> = {
    İ: 'I',
    ı: 'i',
    Ş: 'S',
    ş: 's',
    Ğ: 'G',
    ğ: 'g'
  };

  return text.replace(/[\u0100-\u017F]/g, (ch) => map[ch] ?? ch);
}
